import { useEffect, useRef } from 'react';
import { cameraStreamManager } from 'services/CameraStream/CameraStreamManager';
import { isTransactionStreamTab } from 'utils/transactionSubStream';

/**
 * Transaction tabs: plays the stream type a camera tile shows whenever it changes after the stream is activated, for
 * the changes useExpandCamera does not play: entering or leaving fullscreen, the expanded view moving to another camera
 * or an image (Alt+arrow, image expand) and a base stream type change (transactionSubStreamConfigEnabled). Expanding and
 * collapsing a camera are played by useExpandCamera; a repeat of the same type here is a no-op in the stream scheduler.
 * With the flag off a transaction tile always shows MAIN, so this never plays anything.
 */
const useTransactionStreamTypeSync = ({ streamTypeShow, isExpanded, tabId, isTabActive, isStreamActivated, videoOutputId }) => {
    const shownRef = useRef(streamTypeShow);

    useEffect(() => {
        if (shownRef.current === streamTypeShow) return;
        shownRef.current = streamTypeShow;
        if (isExpanded || !isTransactionStreamTab(tabId) || !isTabActive || isStreamActivated !== true) return;
        cameraStreamManager.playStreamType(streamTypeShow, videoOutputId);
    }, [streamTypeShow, isExpanded, tabId, isTabActive, isStreamActivated, videoOutputId]);
};

export default useTransactionStreamTypeSync;
